import React from "react";
import "./PartyMakeup.css";

function PartyMakeup(props) {
  const { children, className } = props;

  return (
    <div className={`party-makeup-3 border-1px-sonic-silver ${className || ""}`}>
      <div className="party-makeup-4 poppins-medium-tundora-10px">{children}</div>
    </div>
  );
}

export default PartyMakeup;
